/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Filesizelimitdesc3Inputs */

const zh_upload_filesizelimitdesc3 = /** @type {(inputs: Upload_Filesizelimitdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费版单文件上传限制为 100MB，升级到 Pro 可解除限制`)
};

const en_upload_filesizelimitdesc3 = /** @type {(inputs: Upload_Filesizelimitdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free plan limits uploads to 100MB per file. Upgrade to Pro to remove this limit`)
};

const es_upload_filesizelimitdesc3 = /** @type {(inputs: Upload_Filesizelimitdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El plan gratuito limita las subidas a 100MB por archivo. Actualiza a Pro para eliminar este límite`)
};

/**
* | output |
* | --- |
* | "Free plan limits uploads to 100MB per file. Upgrade to Pro to remove this limit" |
*
* @param {Upload_Filesizelimitdesc3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const upload_filesizelimitdesc3 = /** @type {((inputs?: Upload_Filesizelimitdesc3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Filesizelimitdesc3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_upload_filesizelimitdesc3(inputs)
	if (locale === "en") return en_upload_filesizelimitdesc3(inputs)
	return es_upload_filesizelimitdesc3(inputs)
});
export { upload_filesizelimitdesc3 as "upload_fileSizeLimitDesc" }